import { render, staticRenderFns } from "./Dependents.vue?vue&type=template&id=1d8e56e4&"
import script from "./Dependents.vue?vue&type=script&lang=js&"
export * from "./Dependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports